import React from "react";
import Login from "components/Login";
import { Routes, Route, Navigate } from "react-router-dom";
import { AmendManualOrders } from "components/AmendManualOrders";
import { CreateOrders } from "components/ManualOrders";
import { DownloadCustomerDemands } from "components/DownloadCustomerDemands";
import { DownloadEmergencyOrderReport } from "components/DownloadEmergencyOrderReport";
import { EmergencyOrdersUploadScreen } from "components/EmergencyOrders";
import { Home } from "components/Home";
import { Layout } from "components/Layout";
import { NotAuthorized } from "components/NotAuthorized";
import { PageNotFound } from "components/PageNotFound";
import { PrivateRoute } from "navigation/PrivateRoute";
import { UploadCustomerDemands } from "components/UploadCustomerDemands";
import { useSelector } from "react-redux";
import { Validate } from "components/Validate";
import { ViewManualOrders } from "components/ViewManualOrders/ViewManualOrders";
import { ViewManualOrdersAuditDetails } from "components/ViewManualOrders/ViewManualOrdersAuditDetails";
import { PAGE } from "components/common/CONSTANTS";
import { ApproveManualOrders } from "components/ApproveManualOrders/ApproveManualOrders";
import { ConfigureGoldenStore } from "components/GoldenStore/GoldenStore";
import { AddUser } from "components/SystemAdministration/AddUser";
import { ErrorFeedback } from "components/Errorfeedback/ErrorFeedback";
import { CreateManualOrderStores } from "components/CreateManualOrderStores/CreateManualOrderStores";
import { CreateUploadSupplierPO } from "components/ManualSupplierPo";
import { CreateManualPOTable } from "components/ManualPoCreateTable/ManualPoCreateTable";
import { UploadManualPurchaseOrderError } from "components/UploadManualPurchaseOrderError/UploadManualPurchaseOrderError";
import { POSummary } from "components/POSummary/POSummary";
import { SplitPO } from "components/SplitPO/SplitPO";
import { ManualPurchaseOrderEnquiry } from "components/ManualPurchaseOrderEnquiry/ManualPurchaseOrderEnquiry";
import { ManualPurchaseOrderLifecycle } from "components/ManualPurchaseOrderLifecycle/ManualPurchaseOrderLifecycle";
import { AmendPO } from "components/AmendPO/AmendPO";
import { DoNotOrderList } from "components/DoNotOrderList/DoNotOrderList";
import { ItemExclusionConfiguration } from "components/ItemExclusionConfiguration/ItemExclusionConfiguration";
import { SupplierDestinationConfiguration } from "components/SupplierDestinationConfiguration/SupplierDestinationConfiguration";
import { MaxOrderQuantityConfiguration } from "components/MaxOrderQuantityConfiguration";
import { MaxOrderQuantityDownloadReport } from "components/MaxOrderQuantityConfiguration/MaxOrderQuantityDownloadReport";
import { UploadReceiptFile } from "components/UploadReceiptFile/UploadReceiptFile";
export const RouterConfig = () => {
  const userType = useSelector((state) => state.user);
  const { accessiblePages } = userType.userType;
  return (
    <div>
      <Layout>
        <Routes>
          <Route exact path={"/"} element={<Login />} />

          <Route path={PAGE.NOT_AUTHORIZED.url} element={<NotAuthorized />} />

          <Route path="*" element={<PageNotFound />} />

          <Route element={<PrivateRoute />}>
            <Route exact path={PAGE.HOME.url} element={<Home />} />
            <Route
              exact
              path={PAGE.MANAGE_USER.url}
              element={
                accessiblePages &&
                  accessiblePages[PAGE.MANAGE_USER.key] &&
                  accessiblePages[PAGE.MANAGE_USER.key].length > 0 ? (
                  <AddUser />
                ) : (
                  <Navigate to={PAGE.NOT_AUTHORIZED.url} />
                )
              }
            />
            <Route
              exact
              path={PAGE.DOWNLOAD_CUSTOMER_DEMANDS.url}
              element={
                accessiblePages &&
                  accessiblePages[PAGE.DOWNLOAD_CUSTOMER_DEMANDS.key] &&
                  accessiblePages[PAGE.DOWNLOAD_CUSTOMER_DEMANDS.key].length >
                  0 ? (
                  <DownloadCustomerDemands />
                ) : (
                  <Navigate to={PAGE.NOT_AUTHORIZED.url} />
                )
              }
            />
            <Route
              exact
              path={PAGE.UPLOAD_CUSTOMER_DEMANDS.url}
              element={
                accessiblePages &&
                  accessiblePages[PAGE.UPLOAD_CUSTOMER_DEMANDS.key] &&
                  accessiblePages[PAGE.UPLOAD_CUSTOMER_DEMANDS.key].length > 0 ? (
                  <UploadCustomerDemands />
                ) : (
                  <Navigate to={PAGE.NOT_AUTHORIZED.url} />
                )
              }
            />

            <Route
              exact
              path={PAGE.UPLOAD_EMERGENCY_ORDERS.url}
              element={
                accessiblePages &&
                  accessiblePages[PAGE.UPLOAD_EMERGENCY_ORDERS.key] &&
                  accessiblePages[PAGE.UPLOAD_EMERGENCY_ORDERS.key].length > 0 ? (
                  <EmergencyOrdersUploadScreen />
                ) : (
                  <Navigate to={PAGE.NOT_AUTHORIZED.url} />
                )
              }
            />

            <Route
              exact
              path={PAGE.DOWNLOAD_EMERGENCY_ORDERS.url}
              element={
                accessiblePages &&
                  accessiblePages[PAGE.DOWNLOAD_EMERGENCY_ORDERS.key] &&
                  accessiblePages[PAGE.DOWNLOAD_EMERGENCY_ORDERS.key].length >
                  0 ? (
                  <DownloadEmergencyOrderReport />
                ) : (
                  <Navigate to={PAGE.NOT_AUTHORIZED.url} />
                )
              }
            />

            <Route
              exact
              path={PAGE.VALIDATE_EMERGENCY_ORDERS.url}
              element={
                accessiblePages &&
                  accessiblePages[PAGE.UPLOAD_EMERGENCY_ORDERS.key] &&
                  accessiblePages[PAGE.UPLOAD_EMERGENCY_ORDERS.key].length > 0 ? (
                  <Validate />
                ) : (
                  <Navigate to={PAGE.NOT_AUTHORIZED.url} />
                )
              }
            />

            <Route
              exact
              path={PAGE.AMEND_MANUAL_ORDERS.url}
              element={
                accessiblePages &&
                  accessiblePages[PAGE.AMEND_MANUAL_ORDERS.key] &&
                  accessiblePages[PAGE.AMEND_MANUAL_ORDERS.key].length > 0 ? (
                  <AmendManualOrders />
                ) : (
                  <Navigate to={PAGE.NOT_AUTHORIZED.url} />
                )
              }
            />
            <Route
              exact
              path={PAGE.APPROVE_MANUAL_ORDERS.url}
              element={
                accessiblePages &&
                  accessiblePages[PAGE.APPROVE_MANUAL_ORDERS.key] &&
                  accessiblePages[PAGE.APPROVE_MANUAL_ORDERS.key].length > 0 ? (
                  <ApproveManualOrders />
                ) : (
                  <Navigate to={PAGE.NOT_AUTHORIZED.url} />
                )
              }
            />
            <Route
              exact
              path={PAGE.SITE_CANTEEN.url}
              element={
                accessiblePages &&
                  accessiblePages[PAGE.SITE_CANTEEN.key] &&
                  accessiblePages[PAGE.SITE_CANTEEN.key].length > 0 ? (
                  <CreateManualOrderStores />
                ) : (
                  <Navigate to={PAGE.NOT_AUTHORIZED.url} />
                )
              }
            />
            <Route
              exact
              path={PAGE.GOLDEN_STORE.url}
              element={
                accessiblePages &&
                  accessiblePages[PAGE.GOLDEN_STORE.key] &&
                  accessiblePages[PAGE.GOLDEN_STORE.key].length > 0 ? (
                  <ConfigureGoldenStore />
                ) : (
                  <Navigate to={PAGE.NOT_AUTHORIZED.url} />
                )
              }
            />
            <Route
              exact
              path={PAGE.VIEW_MANUAL_ORDERS.url}
              element={
                accessiblePages &&
                  accessiblePages[PAGE.VIEW_MANUAL_ORDERS.key] &&
                  accessiblePages[PAGE.VIEW_MANUAL_ORDERS.key].length > 0 ? (
                  <ViewManualOrders />
                ) : (
                  <Navigate to={PAGE.NOT_AUTHORIZED.url} />
                )
              }
            />
            <Route
              exact
              path={PAGE.VIEW_MANUAL_ORDERS_AUDIT_DETAILS.url}
              element={
                accessiblePages &&
                  accessiblePages[PAGE.VIEW_MANUAL_ORDERS_AUDIT_DETAILS.key] &&
                  accessiblePages[PAGE.VIEW_MANUAL_ORDERS_AUDIT_DETAILS.key]
                    .length > 0 ? (
                  <ViewManualOrdersAuditDetails />
                ) : (
                  <Navigate to={PAGE.NOT_AUTHORIZED.url} />
                )
              }
            />

            <Route
              exact
              path={PAGE.CREATE_MANUAL_ORDERS.url}
              element={
                accessiblePages &&
                  accessiblePages[PAGE.CREATE_MANUAL_ORDERS.key] &&
                  accessiblePages[PAGE.CREATE_MANUAL_ORDERS.key].length > 0 ? (
                  <CreateOrders />
                ) : (
                  <Navigate to={PAGE.NOT_AUTHORIZED.url} />
                )
              }
            />

            <Route
              exact
              path={PAGE.ERROR_FEEDBACK.url}
              element={
                accessiblePages &&
                  accessiblePages[PAGE.CREATE_MANUAL_ORDERS.key] &&
                  accessiblePages[PAGE.CREATE_MANUAL_ORDERS.key].length > 0 ? (
                  <ErrorFeedback />
                ) : (
                  <Navigate to={PAGE.NOT_AUTHORIZED.url} />
                )
              }
            />
            <Route
              exact
              path={PAGE.ERROR_FEEDBACK.url}
              element={
                accessiblePages &&
                  accessiblePages[PAGE.AMEND_MANUAL_ORDERS.key] &&
                  accessiblePages[PAGE.AMEND_MANUAL_ORDERS.key].length > 0 ? (
                  <ErrorFeedback />
                ) : (
                  <Navigate to={PAGE.NOT_AUTHORIZED.url} />
                )
              }
            />
            <Route
              exact
              path={PAGE.UPLOAD_CREATE_MANUAL_ORDER_PO.url}
              element={
                accessiblePages &&
                  accessiblePages[PAGE.UPLOAD_CREATE_MANUAL_ORDER_PO.key] &&
                  accessiblePages[PAGE.UPLOAD_CREATE_MANUAL_ORDER_PO.key].length > 0 ? (
                  <CreateUploadSupplierPO />
                ) : (
                  <Navigate to={PAGE.NOT_AUTHORIZED.url} />
                )
              }
            />
            <Route
              exact
              path={PAGE.PO_SUMMARY.url}
              element={
                accessiblePages &&
                  accessiblePages[PAGE.PO_SUMMARY.key] &&
                  accessiblePages[PAGE.PO_SUMMARY.key].length > 0 ? (
                  <POSummary />
                ) : (
                  <Navigate to={PAGE.NOT_AUTHORIZED.url} />
                )
              }
            />

            <Route
              exact
              path={PAGE.UPLOAD_MANUAL_PO_ERROR.url}
              element={
                accessiblePages &&
                  accessiblePages[PAGE.UPLOAD_MANUAL_PO_ERROR.key] ? (
                  <UploadManualPurchaseOrderError />
                ) : (
                  <Navigate to={PAGE.NOT_AUTHORIZED.url} />
                )
              }
            />
            <Route
              exact
              path={PAGE.SPLIT_PO.url}
              element={
                accessiblePages &&
                  accessiblePages[PAGE.SPLIT_PO.key] ? (
                  <SplitPO />
                ) : (
                  <Navigate to={PAGE.NOT_AUTHORIZED.url} />
                )
              }
            />
            <Route
              exact
              path={PAGE.PO_ENQUIRY.url}
              element={
                accessiblePages &&
                  accessiblePages[PAGE.PO_ENQUIRY.key] ? (
                  <ManualPurchaseOrderEnquiry />
                ) : (
                  <Navigate to={PAGE.NOT_AUTHORIZED.url} />
                )
              }
            />
            <Route
              exact
              path={PAGE.PO_LIFECYCLE.url}
              element={
                accessiblePages &&
                  accessiblePages[PAGE.PO_LIFECYCLE.key] ? (
                  <ManualPurchaseOrderLifecycle />
                ) : (
                  <Navigate to={PAGE.NOT_AUTHORIZED.url} />
                )
              }
            />
            <Route
              exact
              path={PAGE.CREATE_MANUAL_ORDER_PO.url}
              element={
                accessiblePages &&
                  accessiblePages[PAGE.CREATE_MANUAL_ORDER_PO.key] &&
                  accessiblePages[PAGE.CREATE_MANUAL_ORDER_PO.key].length > 0 ? (
                  <CreateManualPOTable />
                ) : (
                  <Navigate to={PAGE.NOT_AUTHORIZED.url} />
                )
              }
            />

            <Route
              exact
              path={PAGE.AMEND_PO.url}
              element={
                accessiblePages &&
                  accessiblePages[PAGE.AMEND_PO.key] ? (
                  <AmendPO />
                ) : (
                  <Navigate to={PAGE.NOT_AUTHORIZED.url} />
                )
              }
            />

            <Route
              exact
              path={PAGE.DO_NOT_ORDER_LIST.url}
              element={
                accessiblePages &&
                  accessiblePages[PAGE.DO_NOT_ORDER_LIST.key] ? (
                  <DoNotOrderList />
                ) : (
                  <Navigate to={PAGE.NOT_AUTHORIZED.url} />
                )
              }
            />

            <Route
              exact
              path={PAGE.ITEM_EXCLUSION_CONFIGURATION.url}
              element={
                accessiblePages &&
                  accessiblePages[PAGE.ITEM_EXCLUSION_CONFIGURATION.key] ? (
                  <ItemExclusionConfiguration />
                ) : (
                  <Navigate to={PAGE.NOT_AUTHORIZED.url} />
                )
              }
            />

            <Route
              exact
              path={PAGE.SUPPLIER_DESTINATION_CONFIGURATION.url}
              element={
                accessiblePages &&
                  accessiblePages[PAGE.SUPPLIER_DESTINATION_CONFIGURATION.key] ? (
                  <SupplierDestinationConfiguration />
                ) : (
                  <Navigate to={PAGE.NOT_AUTHORIZED.url} />
                )
              }
            />
            <Route
              exact
              path={PAGE.ORDER_PAD_MAX_CAP.url}
              element={<MaxOrderQuantityConfiguration />}
            />
            <Route
              exact
              path={PAGE.MAX_CAP_DOWNLOAD_EXTRACT.url}
              element={<MaxOrderQuantityDownloadReport />}
            />
            <Route
              exact
              path={PAGE.UPLOAD_PO_RECEIPT_FILE.url}
              element={
                accessiblePages &&
                  accessiblePages[PAGE.UPLOAD_PO_RECEIPT_FILE.key] ? (
                  <UploadReceiptFile />
                ) : (
                  <Navigate to={PAGE.NOT_AUTHORIZED.url} />
                )
              }
            />
          </Route>
        </Routes>
      </Layout>
    </div>
  );
};
